<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="BellIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('Alert Information') }}
      </h4>
    </div>

    <b-row class="mt-2">

      <b-col cols="12" md="12">
        <b-form-group :label="$t('Alert Name')" label-for="vi-name-id">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="alertData.name" id="vi-name-id" :state="errors && ('name' in errors) ? false : null"
              :placeholder="$t('Alert Name')" />
          </b-input-group>
          <small v-if="errors && ('name' in errors)" class="text-danger">
            {{ $t(errors['name'][0]) }}
          </small>
        </b-form-group>
      </b-col>




      <!-- category  -->

      <b-col cols="12" md="12">
        <b-form-group :label="$t('Alert Type')" label-for="vi-category-id">
          <v-select :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" v-model="alertData.type" :state="null"
            :options="lists.types" :getOptionLabel="d => $t(d.name)" :reduce="d => d.id" />
          <small v-if="errors && ('type' in errors)" class="text-danger">
            {{ $t(errors['type'][0]) }}
          </small>
        </b-form-group>
      </b-col>



      <b-col cols="12" md="12">
        <b-form-group :label="$t('Alert Notificator')" label-for="vi-category-id">
          <v-select multiple :close-on-select="false" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :state="null" v-model="alertData.notificators" :options="lists.notificatorsOptions"
            :getOptionLabel="d => $t(d.name)" :reduce="d => d.id" />
          <small v-if="errors && ('notificators' in errors)" class="text-danger">
            {{ $t(errors['notificators'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <b-col cols="6" style="margin-bottom:2rem">
        <b-form-group :label="$t('from')" label-for="timepicker-start">

          <b-form-timepicker id="timepicker-start" v-model="alertData.from" show-seconds now-button reset-button
            :hour12="false"   hourCycle="h23" v-bind="labels[$store.getters['auth/getPreferLang']] || {}"
            :locale="$store.getters['auth/getPreferLang']" />
          <small v-if="errors && ('from' in errors)" class="text-danger">
            {{ $t(errors['from'][0]) }}
          </small>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('to')" label-for="timepicker-end">

          <b-form-timepicker  id="timepicker-end" v-model="alertData.to" show-seconds now-button reset-button
            :hour12="false"   hourCycle="h23" v-bind="labels[$store.getters['auth/getPreferLang']] || {}"
            :locale="$store.getters['auth/getPreferLang']" />
          <small v-if="errors && ('to' in errors)" class="text-danger">
            {{ $t(errors['to'][0]) }}
          </small>
        </b-form-group>
      </b-col><br />



      <b-col md="12" xl="12" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('all Devices')" label-for="plate-left-char">
          <b-form-checkbox v-model="alertData.allDevices" :value="true" />

          <small v-if="errors && ('allDevices' in errors)" class="text-danger">
            {{ $t(errors['allDevices'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="12" xl="12" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('all allGeofences')" label-for="plate-left-char">
          <b-form-checkbox v-model="alertData.allGeofences" :value="true" />

          <small v-if="errors && ('allGeofences' in errors)" class="text-danger">
            {{ $t(errors['allGeofences'][0]) }}
          </small>

        </b-form-group>
      </b-col>

    </b-row>
  </div>

</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BFormCheckbox
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed } from '@vue/composition-api'
import store from '@/store'
import { BFormTimepicker } from 'bootstrap-vue'
export default {

  components: {
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BFormCheckbox,
    vSelect,
    OrbitSpinner,
    BFormTimepicker
  },

  setup() {

    const labels = {
      ar: {
        labelNoTimeSelected: 'لا وقت المختار',
        labelHours: 'ساعات',
        labelMinutes: 'الدقائق',
        labelSeconds: 'ثواني',
        labelCloseButton: 'اغلاق',
        labelResetButton: 'مسح',
        labelNowButton: 'الأن'
      }
    }

    const s = store.state.alert



    const alertData = computed(() => store.state.alert.data)
    const errors = computed(() => s.errors)



    const lists = computed(() => {

      return {

        types: s.typesOptions,
        notificatorsOptions: s.notificatorsOptions
      }
    })


    return {


      alertData,
      lists,
      errors,
      labels,

    }
  }

}
</script>

<style lang="scss">
// @import '@core/scss/vue/libs/vue-select.scss';
// .repeater-form {
//   overflow: hidden;
//   transition: .35s height;
// }

[dir="rtl"] #timepicker-end__dialog_,
[dir="rtl"] #timepicker-start__dialog_ {
  transform: translate3d(335px, 36px, -3px) !important;
  min-width: 199px !important;


}
</style>
